<template>
    <div class="card" v-if="invoice">
        <div class="card-header">
            Invoice events
            <br>
            <small>Timeline of invoice updates and changes</small>
        </div>
        <div class="card-body">
            <ul class="timeline">
                <li class="step" v-for="entity in invoice.status_entities">
                    <h5 class="float-left">{{ `status.${entity.status.name}.title` | lang }}</h5>
                    <small class="float-right">{{ timeSinceTimestamp(entity.created_at) }}</small>
                    <br>
                    <p v-for="comment in entity.comments">
                        {{ comment.comment }}
                    </p>
                    <p v-show="entity.comments.length === 0">
                        {{ `status.${entity.status.name}.comment` | lang }}
                    </p>
                    <div v-show="entity.status.name === 'payment-received'" class="payment-amount received">
                        {{ amount(entity.status.name).amount }} {{ amount(entity.status.name).currency }}
                        <small>Excluding VAT</small>
                    </div>
                    <div v-show="entity.status.name === 'payment-sent'" class="payment-amount received">
                        {{ amount(entity.status.name).amount }} {{ amount(entity.status.name).currency }}
                        <small>After Charge.gg fees ({{ invoice.totalChargeFee }}%)</small>
                    </div>
                    <div v-show="entity.status.name === 'paid'">
                        <div class="salary-calculation">
                            <h6>Salary calculation</h6>
                            <ul>
                                <li>
                                    Payroll Tax ({{ parseFloat(amount(entity.status.name).employee_fee || 0).toFixed(2) }}%)
                                    <br>
                                    <small>
                                        {{ amount(entity.status.name).provision }}
                                        - {{ amount(entity.status.name).payroll_taxes }} {{
                                        amount(entity.status.name).currency }}
                                    </small>
                                    <br>
                                    <b>{{ amount(entity.status.name).brutto }} {{
                                        amount(entity.status.name).currency }}</b>
                                </li>
                                <li>
                                    Personal Tax ({{ parseFloat(amount(entity.status.name).tax_rate || 0).toFixed(2) }}%)
                                    <br>
                                    <small>{{ amount(entity.status.name).brutto }}
                                        - {{ amount(entity.status.name).taxes }} {{ amount(entity.status.name).currency
                                        }}</small>
                                    <br>
                                    <b>{{ amount(entity.status.name).amount }} {{ amount(entity.status.name).currency
                                        }}</b>
                                </li>
                            </ul>
                        </div>
                        <div class="payment-amount paid">{{ amount(entity.status.name).amount }} {{
                            amount(entity.status.name).currency }}
                            <small>Payout after salary calculation</small>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import moment from 'moment';
  import axios from 'axios';

  export default {
    name: 'InvoiceTimeline',
    props: {
      invoiceObj: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        invoice: undefined,
        issues: undefined,
      };
    },
    watch: {},
    computed: {
      currentState() {
        return this.invoice.state.split('\\').pop();
      },
      issueList() {
        // Get list of subjects and filter out duplicates.
        const list = this.issues.map(i => i.subject).filter((v, i, s) => s.indexOf(v) === i);
        return list.join(', ');
      }
    },
    mounted() {
      if (this.invoiceObj) {
        this.invoice = this.invoiceObj;
        this.invoiceLoaded();
      }
      this.$eventHub.$on('invoice-update', data => {
        this.invoice = data;
        this.invoiceLoaded();
      });
      this.$eventHub.$emit('get-update', 'invoice');
    },
    methods: {
      invoiceLoaded() {
        axios.get(`/invoices/${this.invoice.id}/issues`).then((response) => {
          this.issues = response.data;
        });
      },
      timeSinceTimestamp(ts) {
        return moment(ts).format('YYYY-MM-DD HH:mm');
      },
      amount(state) {
        switch (state) {
          case 'payment-received':
            return this.invoice.received_payment;
          case 'payment-sent':
            return this.invoice.sent_payment;
          case 'paid':
            return this.invoice.paid_payment;
        }
        return 0;
      },
      lock() {
        this.locked = true;
      },
      unlock() {
        this.locked = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
